"use strict";
// Autogenerated by sprite compiler (large sprites)
Object.defineProperty(exports, "__esModule", { value: true });
exports.largeSprites = void 0;
exports.largeSprites = {};
